import { useCallback } from 'react';
import { checkPermission } from 'shared/utils/checkPermission';
import useUser from './useUser';
import useCustomer from './useCustomer';
import useDataSource from './useDataSource';

const useCheckPermission = () => {
  const { hasPermission } = useUser();
  const { hasCustomerPermission } = useCustomer();
  const { hasDataSourcePermission } = useDataSource();

  return useCallback((permission) => checkPermission(permission, {
    hasPermission,
    hasCustomerPermission,
    hasDataSourcePermission,
  }), [hasPermission, hasCustomerPermission, hasDataSourcePermission]);
};

export default useCheckPermission;
